/* eslint-disable no-useless-escape */
export const autoSetMacAddress = (value) => {
  let transValue;
  value = value + "";

  transValue = value
    .replace(
      /^([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9aa-fA-F]{2})([0-9a-fA-F]{2})$/,
      "$1:$2:$3:$4:$5:$6"
    )
    .toUpperCase();

  return transValue;
};

export const autoHyphen = (key, value) => {
  let preValue = value;
  value = "" + value;
  value = value.replace(/-/g, "");

  if (key === "comNum") {
    value = value.replace(/(\d{3})\-?(\d{2})\-?(\d{5})/, "$1-$2-$3");
    return value;
  }
  if (key === "rgeNum") {
    value = value.replace(/(\d{6})\-?(\d{7})/, "$1-$2");
    return value;
  }
  if (key === "juminNum") {
    value = value.replace(/(\d{6})\-?(\d{7})/, "$1-$2");
    return value;
  }
  if (key === "phone" || key === "fax" || key === "mobile") {
    const regExpHyphenNumber = /^[\d -]+$/;
    let v = value;
    if (regExpHyphenNumber.test(v)) {
      v = v.replaceAll("-", "");
      if (!isNaN(v)) {
        v = v
          .replace(
            /(^02|^0505|^1[0-9]{3}|^0[0-9]{2})([0-9]+)?([0-9]{4})$/,
            "$1-$2-$3"
          )
          .replace("--", "-");
      }
    }
    return v;
  }
  if (key === "accountNum") {
    value = Number(value);
    return value;
  }

  return preValue;
};
